import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "flex"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = ["data-tags"];
const _hoisted_4 = ["data-multi"];
const _hoisted_5 = {
  class: "button-label"
};
import { computed, ref, getCurrentInstance, onMounted, onUnmounted } from "vue";
import { useConfiguratorStore } from "@/stores/configuratorData";
import { isProductSelected, isCodingCertificate, isCodingLabel } from "@/utils/responseUtil";
import { openFullLoading } from "@/utils/tools";
import OptionalAssemblyDialog from "./OptionalAssemblyDialog.vue";
import { useI18n } from "vue-i18n";
export default /*@__PURE__*/_defineComponent({
  __name: 'ProductAssembly',
  props: {
    currentCodingItem: {},
    marginLeft: {},
    currentIndex: {}
  },
  setup(__props) {
    const {
      eventBus
    } = getCurrentInstance()?.appContext.config.globalProperties ?? {
      eventBus: undefined
    };
    const {
      t
    } = useI18n();
    const store = useConfiguratorStore();
    const isDevice = computed(() => {
      const userAgent = navigator.userAgent || navigator.vendor;
      return /android|avantgo|blackberry|iemobile|ipad|iphone|ipod|opera mini|opera mobi|palm|pocket|psp|series(4|6)0|symbian|windows ce|windows phone|xda|xiino/i.test(userAgent) ? true : false;
    });
    const props = __props;
    const isHovered = ref(false);
    function handleMouseEnter() {
      eventBus?.emit("hoverStateChange", true);
    }
    function handleMouseLeave() {
      eventBus?.emit("hoverStateChange", false);
    }
    onMounted(() => {
      eventBus.on("hoverStateChange", state => {
        isHovered.value = state;
      });
    });
    onUnmounted(() => {
      eventBus.off("hoverStateChange");
    });
    const optional = computed(() => {
      return store.selectedAssemblies.find(assembly => assembly.codeTypeId === props.currentCodingItem?.CodeTypeId)?.optional;
    });
    const getMarginLeft = computed(() => {
      if (props.currentIndex === 0) {
        return props.marginLeft + "px";
      }
      return 0;
    });
    const isSelected = computed(() => {
      if (isProductSelected(props.currentCodingItem)) {
        return true;
      }
      const childItem = store.getCurrentState?.CurrentCoding.find(item => item.Parent === props.currentCodingItem.CodeTypeId);
      return !!(childItem && isProductSelected(childItem));
    });
    const labels = computed(() => {
      const storedCurrentCoding = store.getCurrentState?.CurrentCoding ?? [];
      let parent = props.currentCodingItem?.Parent;
      if (!parent) {
        parent = props.currentCodingItem?.CodeTypeId;
      }
      const selectedCertificates = store.selectedCertificateGroupByAssembly.find(certificate => certificate.codeTypeId === parent);
      const selectItems = [];
      storedCurrentCoding.forEach(currentCoding => {
        if (store.getCurrentCodingCodes.includes(currentCoding.CodeTypeId) && currentCoding.Parent == selectedCertificates?.codeTypeId) {
          selectItems.push(currentCoding);
        }
        selectedCertificates?.items.filter(sc => {
          if (currentCoding.CodeTypeId === sc.codeTypeId) {
            selectItems.push(currentCoding);
          }
        });
      });
      return [...new Set(selectItems)];
    });
    const labelsLen = computed(() => {
      const items = store.getCurrentState?.CurrentCoding.filter(item => item.Parent === props.currentCodingItem.CodeTypeId && (isLabel(item) || isCertificate(item)));
      return items?.length;
    });
    function isLabel(item) {
      return isCodingLabel(item);
    }
    function isCertificate(item) {
      return isCodingCertificate(item);
    }
    const isDialogOpen = ref(false);
    async function selectLabel(label) {
      const loading = openFullLoading(false, t("text.loading"));
      try {
        await store.ChangeAssembly(label.CodeTypeId);
      } finally {
        loading.close();
      }
    }
    const replaceProductSelectedItem = ref();
    function replaceProduct(itemId) {
      const OriginatorsItem = itemId.Originators ? itemId.Originators[0].CodeTypeId : "";
      useConfiguratorStore().setlastSelectedOption(itemId.Originators[0]);
      useConfiguratorStore().setlastSelectedcodeType(OriginatorsItem);
      isDialogOpen.value = true;
    }
    function isMandatoryProduct() {
      return store.apiConfiguratorResult?.ConfiguratorResult.CurrentState.CurrentCoding[0].CodeTypeId === props.currentCodingItem.CodeTypeId;
    }
    async function changeAssembly() {
      const oldSelected = store.apiConfiguratorResult?.ConfiguratorResult.CurrentState.CurrentCoding.find(isProductSelected)?.CodeTypeId;
      const newSelected = props.currentCodingItem.CodeTypeId;
      if (oldSelected !== newSelected) {
        const loading = openFullLoading(false, t("text.loading"));
        try {
          await store.ChangeAssembly(props.currentCodingItem.CodeTypeId);
          eventBus.emit("ChangeAssemblyAfter", true);
        } finally {
          loading.close();
        }
      }
    }
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['product-assembly', {
          success: __props.currentCodingItem.Complete === 'Yes',
          selected: isSelected.value
        }, {
          hovered: isHovered.value
        }]),
        onMouseenter: handleMouseEnter,
        onMouseleave: handleMouseLeave,
        onClick: changeAssembly,
        style: _normalizeStyle({
          marginLeft: getMarginLeft.value
        })
      }, [_createVNode(OptionalAssemblyDialog, {
        modelValue: isDialogOpen.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => isDialogOpen.value = $event),
        "show-close": false,
        replaceProductSelectedItem: replaceProductSelectedItem.value
      }, null, 8, ["modelValue", "replaceProductSelectedItem"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[3] || (_cache[3] = _createElementVNode("i", {
        class: "iconfont icon-status-attention"
      }, null, -1)), _createElementVNode("span", null, _toDisplayString(__props.currentCodingItem.CodeTypeName), 1)]), _createElementVNode("div", {
        class: "desc",
        "data-tags": labelsLen.value
      }, _toDisplayString(__props.currentCodingItem.Description), 9, _hoisted_3), __props.currentCodingItem.CodeTypeId != _unref(store).getSelectedAssembly?.CodeTypeId ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "assembly-tags",
        "data-multi": labels.value.length > 2
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(labels.value, label => {
        return _openBlock(), _createBlock(_component_el_popover, {
          effect: "dark",
          "popper-class": "assembly-label-popover",
          content: label.CodeTypeName,
          placement: "bottom",
          width: 168,
          trigger: isDevice.value ? 'focus' : 'hover',
          key: label.CodeTypeId
        }, {
          reference: _withCtx(() => [_unref(store).getSelectedCertificates?.includes(label.CodeTypeId) || _unref(store).selectedAssemblies.filter(assembly => assembly.codeTypeId == label.CodeTypeId).length > 0 || label.Optional !== 'Yes' ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: label.Complete === 'Yes' ? 'success' : 'warning',
            title: label.CodeTypeName,
            onClick: _withModifiers($event => selectLabel(label), ["stop"]),
            round: ""
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_svg_icon, {
              "icon-class": isLabel(label) ? 'icon-label' : 'icon-certificate',
              "class-name": isLabel(label) ? 'icon-label' : 'icon-certificate'
            }, null, 8, ["icon-class", "class-name"]), _createElementVNode("span", _hoisted_5, _toDisplayString(label.CodeTypeName), 1)])]),
            _: 2
          }, 1032, ["type", "title", "onClick"])) : _createCommentVNode("", true)]),
          _: 2
        }, 1032, ["content", "trigger"]);
      }), 128))], 8, _hoisted_4)) : _createCommentVNode("", true), !isMandatoryProduct() ? (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 1,
        class: "options-dropdown",
        "popper-class": "configurator-dropdown",
        trigger: "click"
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            onClick: changeAssembly
          }, {
            default: _withCtx(() => [_cache[5] || (_cache[5] = _createElementVNode("i", {
              class: "iconfont icon-edit-fill"
            }, null, -1)), _createElementVNode("span", null, _toDisplayString(__props.currentCodingItem.Category == "Certificates" ? _ctx.$t("button.editCertificate") : __props.currentCodingItem.CodeTypeName == "LABEL" ? _ctx.$t("button.editLabel") : _ctx.$t("button.editAssembly")), 1)]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            disabled: !optional.value,
            class: "red",
            onClick: _cache[2] || (_cache[2] = () => replaceProduct(__props.currentCodingItem))
          }, {
            default: _withCtx(() => [_cache[6] || (_cache[6] = _createElementVNode("i", {
              class: "iconfont icon-reset"
            }, null, -1)), _createElementVNode("span", null, _toDisplayString(_ctx.$t("button.replaceAssembly")), 1)]),
            _: 1
          }, 8, ["disabled"])]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("span", {
          class: "el-dropdown-link",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [...(_cache[4] || (_cache[4] = [_createElementVNode("i", {
          class: "iconfont icon-more-options"
        }, null, -1)]))])]),
        _: 1
      })) : _createCommentVNode("", true)]), _createVNode(_component_svg_icon, {
        "icon-class": "plus-gray",
        name: "plus-gray"
      }), _cache[7] || (_cache[7] = _createElementVNode("div", {
        class: "product-assembly-line"
      }, null, -1))], 38);
    };
  }
});